import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import DomainList from './components/DomainList';
import CategoryGrid from './components/CategoryGrid';
import Features from './components/Features';
import LatestArticles from './components/LatestArticles';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <DomainList />
        <CategoryGrid />
        <Features />
        <LatestArticles />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}